// Components==============
import indexEvent from 'actions/event/index';
import { AnimatePresence } from 'framer-motion';
import React, { createContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './UpcomingEvents.module.scss';
import ActivityCard from 'components/UI/ActivityCard/ActivityCard';
import ActivityModal from 'components/UI/ActivityModal/ActivityModal';
// =========================

const yesterday = new Date();
yesterday.setDate(yesterday.getDate() - 1);

export const UpcomingEventsContext = createContext({});

export default function UpcomingEvents({ numberOfCards }) {
    const [activeActivity, setActiveActivity] = useState(0);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(indexEvent());
    }, []);

    const activities = useSelector((state) =>
        state.event.entities.allIds
            .map((id) => state.event.entities.byId[id])
            .map((activity) => {
                const convertedDate = new Date(activity.date);
                return { ...activity, convertedDate };
            })
    );

    const upcomingActivities = activities
        .sort((a, b) => a.convertedDate.getTime() - b.convertedDate.getTime())
        .filter(
            (activity) =>
                activity.convertedDate.getTime() >= yesterday.getTime()
        );

    return (
        <UpcomingEventsContext.Provider
            value={{
                activeActivity,
                setActiveActivity,
                activities,
                yesterday,
            }}
        >
            {upcomingActivities?.length !== 0 ? (
                <>
                    <div styleName="wrapper">
                        {upcomingActivities
                            .slice(0, numberOfCards || 3)
                            .map(
                                (activity, i) =>
                                    !!activity && (
                                        <ActivityCard
                                            setActiveActivity={
                                                setActiveActivity
                                            }
                                            activity={activity}
                                            key={i}
                                        />
                                    )
                            )}
                    </div>
                    <AnimatePresence>
                        <ActivityModal
                            activeActivity={activeActivity}
                            activities={activities}
                        />
                    </AnimatePresence>
                </>
            ) : (
                <p>Er zijn op dit moment geen activiteiten gepland</p>
            )}
        </UpcomingEventsContext.Provider>
    );
}
